import React from 'react';

import { HeaderBarMovile } from '../HeaderNavegacion/HeaderBarMovile'
import { decodeStorage } from '../../functions/storageBase64'
import { useIsMobile } from 'hooks/useIsMobile';

export function HeaderMovilCS() {

    const { isMobile } = useIsMobile();
    const isLoged = decodeStorage('session_token')
    const profile = decodeStorage('profileData')

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? null
                    : 
                        <header className="hiddenDesktop">
                            <div className="container">
                                <div className="menuPrincipal">
                                    {/* <HeaderBarMovile isLoged={isLoged} profile={profile} /> */}
                                </div>
                            </div>
                        </header>
                : null
            }
        </>
    )
}